import React, { useState } from 'react';
import { Lock } from 'lucide-react'; 
import { login } from "./services/api";

export const LoginForm = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for missing credentials and log an error to the console.
    if (!username || !password) {
      console.error("Missing credentials: Please enter both username and password");
      return;
    }

    setIsLoading(true);
    try {
      const success = await login(username, password);
      if (success) {
        // Login successful: call the onLoginSuccess callback
        onLoginSuccess();
      } else {
        // Login failed: log error to the console.
        console.error("Login failed: Please check your credentials and try again.");
      }
    } catch (error) {
      // Log unexpected errors.
      console.error("An unexpected error occurred. Please try again.", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    // Changed: Added flex, justify-center, and items-center to center the div.
    <div className="h-screen w-full bg-gray-900 text-white flex justify-center items-center">
      <div className="max-w-md w-full p-6 bg-gray-900 rounded-xl shadow-2xl border border-gray-700">
        <div className="flex items-center justify-center mb-4">
          <Lock size={32} className="text-blue-400 mr-2" />
          <h2 className="text-2xl font-bold text-white">Login</h2>
        </div>
        <p className="text-gray-400 text-center mb-6">
          Enter your credentials to access the chat interface
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label className="block text-sm text-gray-400 mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="w-full p-3 rounded bg-gray-800 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-5">
            <label className="block text-sm text-gray-400 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full p-3 rounded bg-gray-800 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};
